export default {
    title: 'Analytics Reports',
    create: 'Create Report',
    'create-new': 'Create new report',
    tab: 'Tab',
    'tab-name': 'Tab name',
    'add-tab': 'Add tab',
    section: 'Section',
    'section-name': 'Section name (optional)',
    'section-base-width': 'Base width (px)',
    'add-section': 'Add section',
    'filter-fields': 'Filter fields',
    'add-filter-field': 'Add filter field',
    'report-filters': 'Report filters',
    'no-filter-fields': 'Add widgets first to configure filter fields',
    'select-filter-fields': 'Select filter fields',
    icon: 'Icon',
    'report-name': 'Report Name',
    'load-error': 'This report could not be loaded. You may not have access to it.',
    widgets: 'Widgets',
    'add-widget': 'Add widget',
    'remove-widget-confirm': {
        title: 'Remove widget',
        description: 'Are you sure you want to remove "{name}"?',
    },
    'widget-types': {
        insight: {
            'default-name': 'Record Insights',
            table: 'Table',
            metric: 'Metric',
            field: 'Metric field',
            visualization: 'Visualization',
            filter: 'Filter',
            'group-by': 'Group by field',
            'segment-by': 'Segment by field',
            metrics: {
                count: 'Count',
                avg: 'Average',
                sum: 'Sum',
                min: 'Minimum',
                max: 'Maximum',
            },
            visualizations: {
                single_metric: 'Single Metric',
                pie: 'Pie Chart',
                bar: 'Bar Chart',
                line: 'Line Chart',
            },
            'stacked-bars': 'Stacked Bars',
            'series-sort': 'Series Sort',
            'sort-by-name': 'By Name',
            'sort-by-value': 'By Value',
            threshold: 'Threshold',
            'show-empty-values': '└ Show empty values',
            'date-granularity': '└ Date granularity',
            'multi-value-mode': '└ Multi-value mode',
            'date-granularity-options': {
                day: 'Day',
                week: 'Week',
                month: 'Month',
                quarter: 'Quarter',
                year: 'Year',
            },
            'multi-value-mode-options': {
                expand: 'Expand',
                combine: 'Combine',
            },
            labels: {
                unknown: 'Unknown',
                'no-value': '(no value)',
            },
            errors: {
                'name-missing': 'Widget name is required',
                'table-id-missing': 'Table selection is required',
                'metric-field-id-missing': 'Metric field is required',
            },
        },
        'state-transitions': {
            'default-name': 'State Transition Insights',
            table: 'Table',
            field: 'State field',
            filter: 'Filter',
            metric: 'Metric',
            metrics: {
                any_transition: 'All transitions',
                in_state: 'From state',
                into_state: 'Into state',
                to_terminal: 'Into terminal',
            },
            'metric-descriptions': {
                any_transition: 'how long every state change took, or how many occurred, unfiltered',
                in_state: 'how long records stayed in the selected state(s) before moving on, or how many times they were left',
                into_state: 'how long it took to reach the selected state(s) from whichever state preceded, or how many records transitioned into them',
                to_terminal: 'how long records take to reach a final state, or how many have reached one',
            },
            aggregation: 'Aggregation',
            'states-left': 'States left',
            'states-entered': 'States entered',
            'date-granularity': 'Date granularity',
            visualization: 'Visualization',
            'group-by': 'Group by',
            'group-by-field': 'Group by field',
            aggregations: {
                count: 'Count',
                avg: 'Average',
                sum: 'Sum',
                min: 'Minimum',
                max: 'Maximum',
            },
            visualizations: {
                single_metric: 'Single Metric',
                pie: 'Pie Chart',
                bar: 'Bar Chart',
                line: 'Line Chart',
            },
            'stacked-bars': 'Stacked Bars',
            'series-sort': 'Series Sort',
            'sort-by-name': 'By Name',
            'sort-by-value': 'By Value',
            threshold: 'Threshold',
            'show-empty-values': '└ Show empty values',
            'field-date-granularity': '└ Date granularity',
            'multi-value-mode': '└ Multi-value mode',
            'date-granularity-options': {
                none: 'None',
                day: 'Day',
                week: 'Week',
                month: 'Month',
                quarter: 'Quarter',
                year: 'Year',
            },
            'multi-value-mode-options': {
                expand: 'Expand',
                combine: 'Combine',
            },
            'group-by-options': {
                none: 'None',
                origin: 'Origin',
                state: 'State',
                field: 'Field',
            },
            'duration-unit-caption': 'Values shown in {unit}',
            'duration-units': {
                ms: 'milliseconds',
                s: 'seconds',
                m: 'minutes',
                h: 'hours',
                d: 'days',
            },
            labels: {
                unknown: 'Unknown',
                'no-value': '(no value)',
                'api-origin': 'API',
            },
            errors: {
                'name-missing': 'Widget name is required',
                'table-id-missing': 'Table selection is required',
                'field-id-missing': 'State field is required',
            },
        },
    },
    'widget-name': 'Widget name',
    'widget-width-multiplier': 'Width multiplier',
    refresh: 'Refresh',
    'show-underlying-data': 'Show underlying data',
    'underlying-data': 'Underlying data for widget',
}
